import $ from 'jquery';

class Modal {
	constructor(element) {
		this.element = element;
	}

	show() {
		return new Promise(res => {
			$(this.element).one('show.bs.modal', res);
			$(this.element).modal('show');
		});
	}

	hide() {
		return new Promise(res => {
			$(this.element).one('hide.bs.modal', res);
			$(this.element).modal('hide');
		});
	}

	onHide(func) {
		$(this.element).on('hide.bs.modal', func);
	}

	removeOnHide() {
		$(this.element).off('hide.bs.modal');
	}
}

export default Modal;
